<pfx-sidebar-with-confirmation [(visible)]="visible">
  <div class="pfx-sidebar-header">
    <pfx-entity-header
      [title]="title()"
      [caption]="businessPartnerType() | i18next"
      [icon]="businessPartnerIcon()"
    >
      <pfx-business-partner-header-data
        [businessPartnerId]="businessPartnerId()"
        [showRatings]="false"
      ></pfx-business-partner-header-data>
    </pfx-entity-header>
  </div>

  <pfx-overview-view
    class="mt-4"
    [businessPartnerId]="businessPartnerId()"
  ></pfx-overview-view>

  <div class="pfx-sidebar-footer">
    <div class="flex flex-row justify-around">
      <a [routerLink]="['/business-partner-center/', businessPartnerId()]">{{ 'detailed_view' | i18next }}</a>
    </div>
  </div>
</pfx-sidebar-with-confirmation>
